import { FC } from 'react';

import Logo from '@/components/logo/Logo';

import styles from './DebtsTableHeader.module.scss';

export const DebtsTableHeader: FC = () => {
	return (
		<header className={styles['container']}>
			<h1 className={styles['title']}>Schedule of Business Debt</h1>
			<div className={styles['logo']}>
				<Logo className="company-link" />
			</div>
		</header>
	);
};
